package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.ui.EntityEditor
import ai.flowstorm.common.ui.UiHelpers
import ai.flowstorm.studio.model.Initiation
import ai.flowstorm.studio.model.TesterResult
import ai.flowstorm.studio.resources.space.InitiationResource
import io.kvision.html.ButtonStyle
import io.kvision.html.button
import io.kvision.i18n.tr
import io.kvision.panel.SimplePanel
import kotlinx.coroutines.launch

class PlaylistTestEditor(
    val form: PlaylistTestForm = PlaylistTestForm(),
    val callback: (List<TesterResult>) -> Unit
) : EntityEditor<Initiation>(form, serializer = Initiation.serializer(), deleteEnabled = false) {

    override fun otherButtons(panel: SimplePanel) {
        panel.button(tr("Get Results"), style = ButtonStyle.PRIMARY) {
            marginRight = UiHelpers.spacing
        }.onClick {
            mainScope.launch {
                form.initiationId?.let {
                    callback(InitiationResource.groups(it))
                }
            }
        }
    }
}